import {Box, Typography, useMediaQuery, useTheme} from '@mui/material';
import Carousel from '@jobseeker/lotus/components/Carousel';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Image} from '@jobseeker/lotus/components/Image';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

const MembershipSlider = () => {
  const theme = useWrappedTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const interceptor: any = useInterceptor();
  const {
    proMembership: {carouselItems},
  } = interceptor;
 

  const carouselElements = carouselItems.map((item:{
    "imageUrl":string,
    "heading": string,
    "description":string,
  }, index:number) => (
    <Box
      key={index}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 4,
        backgroundColor: 'border.main',
        borderRadius: 6,
        width: {md: 220, xs: 220, sm: 220},
        marginLeft: {xs: 1.5, md: 0},
        height: '200px',
      }}
    >
      <Image src={item.imageUrl} alt={item.heading} width={104} height={80} />
      <Typography
        gutterBottom
        sx={{
          color: 'secondary.dark',
          fontSize: theme.typography.pxToRem(14),
          fontWeight: 600,
          textAlign: 'center',
          width: {md: 218},
          mt: 2,
        }}
      >
        {item.heading}
      </Typography>
      <Typography
        sx={{
          fontSize: theme.typography.pxToRem(12),
          color: 'black',
          textAlign: 'center',
          lineHeight: {md: '18px'},
        }}
      >
        {item.description}
      </Typography>
    </Box>
  ));

  return (
    <>
      <Box
        sx={{
          marginTop: 5,
          marginBottom: 8,
          marginLeft: {xs: 0, md: 3},
          position: 'relative',
          backgroundColor: 'primary.contrastText',
        }}
      >
        <Box sx={{position: 'relative', mb: 2}}>
          <Typography
            gutterBottom
            component="div"
            sx={{
              color: 'secondary.dark',
              fontSize: {
                xs: theme.typography.pxToRem(18),
                md: theme.typography.pxToRem(24),
              },
              fontWeight: 600,
              textAlign: {xs: 'center', md: 'left'},
              marginBottom: {xs: '30px', md: '40px'},
            }}
          >
            Big Reason to be a{' '}
            <Typography
              component="span"
              sx={{
                fontSize: {
                  xs: theme.typography.pxToRem(18),
                  md: theme.typography.pxToRem(24),
                },
                fontWeight: 600,
                background: theme.palette.pro.main,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Pro Member
            </Typography>
          </Typography>
          <Carousel
            carouselItems={carouselElements}
            hideNavigationOnMobile={isMobile}
            breakpointOverrides={{
              1550: {slidesPerView: 3.4, spaceBetween: 10},
              1440: {slidesPerView: 3.4, spaceBetween: 10},
              1024: {slidesPerView: 3.2, spaceBetween: 12},
              2560: {slidesPerView: 3.4, spaceBetween: 10},
              425: {slidesPerView: 1.3, spaceBetween: 10},
              375: {slidesPerView: 1.15, spaceBetween: 10},
              320: {slidesPerView: 1.1, spaceBetween: 9},
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default MembershipSlider;
